import Vue from 'vue';
import commonObj from 'commonObj';
import fetch from './fetch';
import * as filters from './filters';

Vue.use({
  install(Vue) {
    Vue.prototype.$fetch = fetch;

    Object.keys(filters).forEach((key) => {
      Vue.filter(key, filters[key]);
    });

    Vue.prototype.$curuserid = commonObj.data.userid;
    Vue.prototype.$token = commonObj.data.token;
  }
});

const refSrc = commonObj.utils.getQueryStrFn('refsrc') || 'none';
const cnzz = window._czc || [];

cnzz.push(['_trackEvent', refSrc, commonObj.data.outChangba ? 'outCB' : 'inCB', 'loaded']);

// 为了兼容唱吧 iOS APP 内设置 document.title 无效的问题
if (!commonObj.data.outChangbaNew && commonObj.browser.isIOS) {
  let title = document.title;

  Object.defineProperty(document, 'title', {
    get() {
      return title;
    },

    set(value) {
      if (title === value) {
        return;
      }

      title = value;

      const titleEl = document.getElementsByTagName('title');
      if (titleEl?.[0]) {
        titleEl[0].innerText = title;
      }

      const el = document.createElement('iframe');
      el.style.display = 'none';
      el.onload = () => {
        setTimeout(() => {
          el.remove();
        }, 0);
      };
      el.src = 'about:blank';
      document.body.appendChild(el);
    }
  });
}
